import { useQueryClient } from '@tanstack/react-query';
import { useAPI } from 'src/compass/shared/hooks/reactQuery/useAPI';

const ACCELERATED_COUNT_URL = 'EmpInsAccelMonth/Count';

export function useAcceleratedCount() {
  const { data, isLoading } = useAPI({
    method: 'get',
    url: ACCELERATED_COUNT_URL,
  });

  const { acceleratedCount } = data || {};

  return { acceleratedCount, isLoading };
}

export const useAcceleratedCountInvalidate = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: [ACCELERATED_COUNT_URL] });
  };
};
